/**
 * Pure state helpers for the timeline data object. Each returns a NEW data
 * object with one slice updated — safe to feed straight into a React setState.
 * A stage targets either its single `activity` or its parallel `group` (and a
 * sub-activity within). See docs/timeline-ui.md for the data shape.
 */

export function setStageStatus(data, stageId, status) {
	return {
		...data,
		stages: data.stages.map((s) => (s.id === stageId ? { ...s, activity: { ...s.activity, status } } : s)),
	}
}

export function setStageMeta(data, stageId, meta) {
	return {
		...data,
		stages: data.stages.map((s) =>
			s.id === stageId ? { ...s, activity: { ...s.activity, meta: { ...(s.activity?.meta || {}), ...meta } } } : s
		),
	}
}

export function setItemStatus(data, stageId, itemIndex, status) {
	return {
		...data,
		stages: data.stages.map((s) => {
			if (s.id !== stageId) return s
			const items = s.activity.items.map((it, i) => (i === itemIndex ? { ...it, status } : it))
			return { ...s, activity: { ...s.activity, items } }
		}),
	}
}

export function setStageSummary(data, stageId, summary) {
	return {
		...data,
		stages: data.stages.map((s) => (s.id === stageId ? { ...s, activity: { ...s.activity, summary } } : s)),
	}
}

export function setGroupStatus(data, stageId, status) {
	return {
		...data,
		stages: data.stages.map((s) => (s.id === stageId ? { ...s, group: { ...s.group, status } } : s)),
	}
}

export function setSubStatus(data, stageId, subIndex, status) {
	return {
		...data,
		stages: data.stages.map((s) => {
			if (s.id !== stageId) return s
			const activities = s.group.activities.map((sub, i) => (i === subIndex ? { ...sub, status } : sub))
			return { ...s, group: { ...s.group, activities } }
		}),
	}
}

export function setSubMeta(data, stageId, subIndex, meta) {
	return {
		...data,
		stages: data.stages.map((s) => {
			if (s.id !== stageId) return s
			const activities = s.group.activities.map((sub, i) =>
				i === subIndex ? { ...sub, meta: { ...(sub.meta || {}), ...meta } } : sub
			)
			return { ...s, group: { ...s.group, activities } }
		}),
	}
}

export function setSubItemStatus(data, stageId, subIndex, itemIndex, status) {
	return {
		...data,
		stages: data.stages.map((s) => {
			if (s.id !== stageId) return s
			const activities = s.group.activities.map((sub, i) => {
				if (i !== subIndex) return sub
				const items = sub.items.map((it, k) => (k === itemIndex ? { ...it, status } : it))
				return { ...sub, items }
			})
			return { ...s, group: { ...s.group, activities } }
		}),
	}
}
